export interface HowItWorksStep {
  number: string;
  title: string;
  description: string;
  details: string;
  points: string[];
  audience: 'fan' | 'operator' | 'both';
}

export const howItWorksSteps: HowItWorksStep[] = [
  {
    number: '01',
    title: 'Fans scan and verify',
    description:
      'No app downloads. No passwords. Fans simply scan, verify, and order — then confirm their section, row, and seat once.',
    details:
      'Fans scan a venue QR code at their seat or in concourse signage, verify their phone number with a one-time code, and confirm their section, row, and seat. The entire flow takes under a minute with no app download or password required.',
    points: [
      'QR code scan launches the ordering experience',
      'Secure one-time verification replaces passwords',
      'Seat confirmed once, reused for every order',
    ],
    audience: 'fan',
  },
  {
    number: '02',
    title: 'Orders route automatically',
    description:
      'Every order is automatically routed to the correct section, row, and seat so runners and vendors know exactly where to deliver.',
    details:
      'Once an order is placed, ONI attaches seat metadata and routes it to the correct vendor queue. Runners receive clear delivery instructions — no radio calls, no guesswork about where fans are sitting.',
    points: [
      'Seat data flows from fan to vendor automatically',
      'Runners see section, row, and seat on every ticket',
      'Venue teams can filter and prioritize by section',
    ],
    audience: 'both',
  },
  {
    number: '03',
    title: 'Vendors fulfill from one queue',
    description:
      'Concession teams manage menus, modifiers, and live order status from the ONI admin dashboard on game day.',
    details:
      'Vendors and operators use the ONI admin dashboard to manage live order queues, update item availability, run promotions, and move orders through fulfillment stages. Bulk actions and status updates keep the line moving during peak periods.',
    points: [
      'Live order queue with status updates',
      'Real-time menu and availability management',
      'Bulk actions for high-volume game days',
    ],
    audience: 'operator',
  },
  {
    number: '04',
    title: 'Venues track performance live',
    description:
      'Monitor order volume, revenue, wait times, and vendor performance in real time — without leaving your command center.',
    details:
      'Venue operators get a real-time view of order volume, revenue, average wait times, and per-vendor performance. Analytics update throughout the event so teams can respond to bottlenecks before they become problems.',
    points: [
      'Live revenue and order volume dashboards',
      'Per-vendor performance tracking',
      'Wait time trends across sections',
    ],
    audience: 'operator',
  },
];
